<div class="popup-content">
  <cpb-list-renderer [key]="builderKey" [context]="context"></cpb-list-renderer>
</div>
